import { SbbFormField } from "@sbb-esta/lyne-react/form-field";
import { FormContextHelp } from "components/Forms/FormContextHelp";
import { FormField } from "components/Forms/FormField";
import { getResourceStrict } from "providers";
import React, { CSSProperties, PropsWithChildren } from "react";

import { defaultSize } from "./LyneConstants";
import { LyneLabel } from "./LyneLabel";

export interface LyneInputProps extends PropsWithChildren, FormField {
  name: string;
  size?: "s" | "m" | "l";
  className?: string;
  style?: CSSProperties;
}

export const LyneFormField: React.FC<LyneInputProps> = ({
  name,
  required,
  children,
  size = defaultSize,
  className,
  style,
  label,
  contextHelp,
}) => {
  const labelToUse = label ? getResourceStrict(label) : "";

  return (
    <SbbFormField size={size} data-name={name} className={className} style={style}>
      {labelToUse && <LyneLabel name={name} label={labelToUse} required={required} />}
      {children}
      {contextHelp && label && <FormContextHelp title={label} content={contextHelp} />}
    </SbbFormField>
  );
};
